export default __webpack_public_path__ + "static/media/about.2f6bd585.jpg";